var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6112 9.44176L12.0639 10L12.6112 10.5582C12.9135 10.2499 12.9135 9.75007 12.6112 9.44176ZM10.9694 10L7.3889 13.6523C7.08665 13.9606 7.08665 14.4605 7.3889 14.7688C7.69115 15.0771 8.18119 15.0771 8.48344 14.7688L12.6112 10.5582L12.0639 10L12.6112 9.44176L8.48344 5.23123C8.18119 4.92292 7.69115 4.92292 7.3889 5.23123C7.08665 5.53954 7.08665 6.03941 7.3889 6.34772L10.9694 10Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.abd3e7e8.svg";
export { ForwardRef as ReactComponent };